const parse = json => {
  try {
    return JSON.parse(json);
  } catch {
    return {};
  }
}

export default parse;